import React, {useContext, useEffect, useRef, useState} from "react";
import {Cancel, Save} from "@mui/icons-material";
import {AppbarContentContext} from "../../../../commons/routing/appbar/AppbarContentProvider";
import AppbarActionButton from "../../../../commons/elements/buttons/AppbarActionButton";
import GeneralEditVideoForm from "../utils/GeneralEditVideoForm";
import useNewVideo from "./useNewVideo";
import LoadingProgressIndication from "../../../../commons/elements/progress/loading/LoadingProgressIndication";
import {useIntl} from "react-intl";

const NewVideoSection = () => {

    // Hook to update the appbar
    const {setCurrentAppbarContent} = useContext(AppbarContentContext)

    // Hook providing the save user functionality
    const {
        uploadAndSaveVideo,
        cancel,
        uploadLinkCreationInProgress,
        checkInProgress
    } = useNewVideo()

    // Reference, which holds will hold the user data according to the current form data (from the general user component)
    const editedVideoRef = useRef()

    // Determines if the save button should be enabled.
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(false)

    // Internationalization for simple strings
    const intl = useIntl();

    // Setting the appbar content
    useEffect(() => {
        setCurrentAppbarContent({
            header: intl.formatMessage({
                id: 'app.videos.new.appbar.header',
                defaultMessage: 'Create New Video'
            }),
            description: intl.formatMessage({
                id: 'app.videos.new.appbar.description',
                defaultMessage: 'Describe the video with metadata'
            }),
            actions: <>
                <AppbarActionButton
                    label={intl.formatMessage({
                        id: 'app.videos.new.appbar.actions.save',
                        defaultMessage: 'Create'
                    })}
                    onClick={() => uploadAndSaveVideo(editedVideoRef.current)}
                    icon={<Save/>}
                    disabled={!saveButtonEnabled}/>
                <AppbarActionButton
                    label={intl.formatMessage({
                        id: 'app.videos.new.appbar.actions.cancel',
                        defaultMessage: 'Cancel'
                    })}
                    onClick={() => cancel()}
                    icon={<Cancel/>}/>
            </>,
            progress: checkInProgress || uploadLinkCreationInProgress
        })
    }, [saveButtonEnabled, checkInProgress, uploadLinkCreationInProgress])

    if (uploadLinkCreationInProgress) {
        return <LoadingProgressIndication
            text={intl.formatMessage({
                id: 'app.videos.new.uploadLinkCreation.loading',
                defaultMessage: 'Upload link creation...'
            })}/>
    }

    return (
        <GeneralEditVideoForm editedVideoRef={editedVideoRef}
                              setSaveButtonEnabled={setSaveButtonEnabled}/>
    );
}

export default NewVideoSection